import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(studio)/dj/page.tsx");
